import { ApiErrorCodeEnum } from '../../../enums/api-error-code.enum';

/**
 * Data dispatch result DTO.
 */
export class DataDispatchResultDto {
	errorCode!: ApiErrorCodeEnum;
	message?: string;
	success!: boolean;
}
